app.controller("ReceivedNotificationController", [
    "$scope", "$stateParams", "Students", "$uibModal", "$state", "NotificationService", "$rootScope", "usSpinnerService", "RemindersService",
    function ($scope, $stateParams, Students, $uibModal, $state, NotificationService, $rootScope, usSpinnerService, RemindersService) {
        $scope.notifications = null;
        $scope.totalItems = 0;
        $scope.itemsPerPage = 20;
        $scope.activeTab = 0;

        loadPage($stateParams.page, $scope.query, function () {
            $scope.currentPage = $stateParams.page;
        });

        $scope.goToPage = function (page) {
            $state.go(".", {page: page});
        };

        $scope.changePage = function () {
            $scope.goToPage($scope.currentPage);
        };

        $scope.mark = function (notification) {
            NotificationService.mark({
                notification: notification,
                state: 'read'
            }).then(function () {
                $rootScope.$broadcast('notificationCount', {});
            });
        };

        $scope.markUnread = function (notification, $event) {
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }
            NotificationService.mark({
                notification: notification._id,
                state: 'unread'
            }).then(function () {
                loadPage($stateParams.page, $scope.query);
                $rootScope.$broadcast('notificationCount', {});
            })
        };

        $scope.open = function (item) {
            $uibModal.open({
                controller: "NotificationsWindowController",
                templateUrl: _pb + 'notifications/notification-window.html',
                size: "md",
                backdrop: 'static',
                resolve: {
                    params: function () {
                        return {notification: item.notification};
                    }
                }
            }).result
                .then(function (result) {
                    $scope.mark(item._id);
                    loadPage($stateParams.page, $scope.query);
                }, function () {
                    if (item.state === 'unread') {
                        $scope.mark(item._id);
                        loadPage($stateParams.page, $scope.query);
                    }
                });
        };

        function loadPage(page, query, cb) {
            cb = cb || function () {
                };
            usSpinnerService.spin("root");
            NotificationService.received({
                page: page,
                query: query,
                limit: $scope.itemsPerPage
            }).then(function (data) {
                $scope.notifications = data.docs;
                $scope.totalItems = data.total;
                RemindersService.list({current: true}).then(function(data){
                    $scope.reminders = data.docs;
                    $scope.totalItems += data.total;
                    usSpinnerService.stop("root");
                });
                cb();
            });
        }

        $scope.$on('loadPage', function (event, args) {
            loadPage($stateParams.page, $scope.query);
        });

        $scope.create = function () {
            $state.go("admin.createNotifications", {});
        };

        $scope.openReminder = function(reminder){
            $state.go(reminder.route, reminder.routeParams);
        };

        $scope.snoozeReminder = function(reminder, $event){
            if ($event) {
                $event.preventDefault();
                $event.stopPropagation();
            }

            RemindersService.markAsRead(reminder._id).then(function(){
                loadPage($stateParams.page, $scope.query);
                $rootScope.$broadcast('reminderCount', {});
            });
        };
    }
]);
